import React, { FC, useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { hot } from 'react-hot-loader/root'
import { observer } from 'mobx-react'
import TextModal from 'src/pc/components/text-modal'
import { Button, Checkbox, Form } from 'antd'
import { StyledForm } from '../assets/styled/CustomForm'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { AppStore } from 'src/pc/store/AppStore'

//系统设置缓存key
export const SETTINGS_KEY = 'SETTINGS_KEY'
//不支持系统设置的最高版本
export const SETTINGS_VERSION: [number, number, number, number] = [2, 0, 0, 2224]

// console.log('settings localStorage', localStorage.getItem(SETTINGS_KEY))

const useLocalStorageState = (key: string, defaultValue: any) => {
  const str = localStorage.getItem(key)
  let last
  if (str) {
    try {
      last = JSON.parse(str)
    } catch (e) {}
  }
  const [data, setData] = useState(last ?? defaultValue)
  const setDataFn = (info: any) => {
    setData(info)
    console.log('settings 保存', JSON.stringify(info))
    localStorage.setItem(key, JSON.stringify(info))
    console.log('settings 保存后获取', localStorage.getItem(key))
  }
  return [data, setDataFn]
}

const SettingsModal: FC<{ visible: boolean; onCancel: () => void }> = ({ visible, onCancel }) => {
  const [settings, setSettings] = useLocalStorageState(SETTINGS_KEY, {
    autoStart: false,
    closeAction: 'hide',
    showSpeed: true,
  })
  const [closeAction, setCloseAction] = useState(settings.closeAction)

  const [form] = Form.useForm()
  const { getFieldsValue, setFieldsValue } = form

  const onCloseActionChange = (event: CheckboxChangeEvent, action: string) => {
    if (!event.target.checked) {
      return
    }
    setCloseAction(action)
  }

  const onSave = () => {
    const cfg = getFieldsValue()
    console.log('settings getFieldsValue', cfg)
    Object.keys(cfg).forEach(key => {
      const newValue = cfg[key]
      if (newValue === settings[key as keyof typeof settings]) {
        return
      }
      switch (key) {
        case 'autoStart':
          console.log('settings 自启动=>', newValue)
          //设置、取消自启动
          window.FuluApp?.JSNotifyCppFunc('set_auto_run', ~~newValue)
          break
        case 'closeAction':
          console.log('settings 关闭按钮=>', newValue)
          break
        case 'showSpeed':
          console.log('settings 加速球=>', newValue)
          //隐藏显示加速球
          newValue ? AppStore.speedBall?.show() : AppStore.speedBall?.hide()
          break
        default:
      }
    })
    setSettings(cfg)
    onCancel()
  }

  // useEffect(() => {
  //   //首次默认设置开机自启
  //   const isNew = CompareWithCurrentVersion(SETTINGS_VERSION)
  //   if (!localStorage.getItem(SETTINGS_KEY) && isNew) {
  //     console.log('settings 首次默认设置开机自启')
  //     window.FuluApp?.JSNotifyCppFunc('set_auto_run', 1)
  //     setSettings({
  //       ...settings,
  //       autoStart: true,
  //     })
  //   }
  // }, [AppConfig.Version])

  useEffect(() => {
    if (visible) {
      setFieldsValue(settings)
      setCloseAction(settings.closeAction)
    }
  }, [visible, settings])

  useEffect(() => {
    setFieldsValue({
      ...getFieldsValue(),
      closeAction,
    })
  }, [closeAction])

  //同步设置到store
  useEffect(() => {
    AppStore.settings = settings
  }, [settings])

  return (
    <StyledSettingsModal
      title="系统设置"
      centered
      width={505}
      closable={true}
      visible={visible}
      onCancel={onCancel}
      footer={
        <StyledFooter>
          <Button className="cancel" onClick={onCancel}>
            取消
          </Button>
          <Button className="save" onClick={onSave}>
            保存
          </Button>
        </StyledFooter>
      }
    >
      <StyledSettingsBox>
        {/* @ts-ignore */}
        <StyledSettingForm form={form} initialValues={settings}>
          {/*<Form.Item>*/}
          {/*  <header className="title">启动设置</header>*/}
          {/*  <main className="main">*/}
          {/*    <Form.Item name="autoStart" noStyle={true} valuePropName={'checked'}>*/}
          {/*      <Checkbox>开机自启动</Checkbox>*/}
          {/*    </Form.Item>*/}
          {/*  </main>*/}
          {/*</Form.Item>*/}
          <Form.Item name="closeAction">
            <header className="title">当关闭窗口时</header>
            <main className="main">
              <Checkbox.Group value={[closeAction]}>
                <Checkbox value={'hide'} onChange={e => onCloseActionChange(e, 'hide')}>
                  隐藏到任务栏托盘
                </Checkbox>
                <Checkbox value={'close'} onChange={e => onCloseActionChange(e, 'close')} style={{ marginLeft: 24 }}>
                  退出主程序
                </Checkbox>
              </Checkbox.Group>
            </main>
          </Form.Item>
          <Form.Item>
            <header className="title">加速设置</header>
            <main className="main">
              <Form.Item name="showSpeed" noStyle={true} valuePropName={'checked'}>
                <Checkbox>显示寒光加速器下载球</Checkbox>
              </Form.Item>
            </main>
          </Form.Item>
        </StyledSettingForm>
      </StyledSettingsBox>
    </StyledSettingsModal>
  )
}

const StyledSettingForm = styled(StyledForm)`
  .title {
    font-size: 14px;
    color: #b0b0b0;
    line-height: 1;
    margin-bottom: 14px;
  }

  .main {
    .ant-checkbox-wrapper {
      font-size: 13px;
      color: #fff;
    }
  }

  .ant-form-item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    padding-left: 10px;
    padding-bottom: 20px;
    margin-bottom: 20px;

    &:nth-last-of-type(1) {
      margin-bottom: 0;
    }
  }

  .ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {
    border-color: #6c6c6c;
  }
`

const StyledSettingsBox = styled.div`
  color: #fff;
`

const StyledFooter = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .save {
    width: 80px;
    height: 32px;
    font-size: 13px;
    text-align: center;
    line-height: 32px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    padding: 0;
    color: var(--main-btn-text-color);
    font-weight: bold;
    margin-left: 20px !important;
    background-image: linear-gradient(
      270deg,
      var(--main-btn-gradient-dark-color) 0%,
      var(--main-btn-gradient-light-color) 100%
    );

    &:hover {
      filter: brightness(1.1);
    }
  }

  .cancel {
    width: 80px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 13px;
    color: #fff;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.4);
  }
`

export const StyledSettingsModal = styled(TextModal)`
  .ant-modal-body {
    padding: 20px 20px 0;
  }

  .ant-modal-footer {
    &:before {
      display: none;
    }
  }
`

export default hot(observer(SettingsModal))
